<div class="card">
  <markant-card>
    <div slot="markant-card__headline">
      <p>IAM Tenant toggle</p>
    </div>
    <div class="content" slot="markant-card__content">
      <p>Using new auth0 iam tenant on/off:</p>
      <markant-switch
        [checked]="isMarkantCentralTenant"
        (checkedChange)="onCheckedChanged($any($event).detail)"
      >
      </markant-switch>
    </div>
  </markant-card>
</div>
